
export const PageHeader = {
    
    init() {
       

        // Funnel DNI
        if($('.dni_property_id').length > 0 ){
            var propertyId = $('.dni_property_id').val();
            if( $(".lead_source_schedule").val() == ''){
                $(".contact-us-form #input_2_17").val('10491');
                $(".lead_source_schedule").val('10491');
            }
            setTimeout(function(){
                FunnelDNI({
                    "apiKey": "b96edc336cf043fa830d9e92f4ec7e6d",
                    "communityId": propertyId,
                    "onPhoneNumberReady": function(data) {
                        if(data.lead_source_id == ''){
                            $(".contact-us-form #input_2_17").val('10491');
                            $(".lead_source_schedule").val('10491');
                        }else{
                            $(".contact-us-form #input_2_17").val(data.lead_source_id);
                            $(".lead_source_schedule").val(data.lead_source_id);
                        }
                    }
                });

            },500);
        }
    },
};

